module.exports = __webpack_public_path__ + "img/fw／pic.21763c23.png";